module.exports = __webpack_public_path__ + "img/banner.a06d678b.png";